import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ComoTrabalhoPage from "./pages/ComoTrabalhoPage";
import AcompanhamentosPage from "./pages/AcompanhamentosPage";
import ProcessoPage from "./pages/ProcessoPage";
import ContactoPage from "./pages/ContactoPage";
import SobrePage from "./pages/SobrePage";

function App() {
  return (
    <div className="app-wrapper">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/como-trabalho" element={<ComoTrabalhoPage />} />
            <Route path="/acompanhamentos" element={<AcompanhamentosPage />} />
            <Route path="/processo" element={<ProcessoPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="/sobre" element={<SobrePage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
